import { LabTests } from './../partner/lab-dashboard/lab-dashboard.component';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from './../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LabService implements OnInit {
  
private apiUrl = environment.apiUrl
labData:any = JSON.parse(localStorage.getItem('logindata'))
  headers:HttpHeaders 
  constructor(private http:HttpClient) {
   
   
   
   }
   ngOnInit(){
this.headers = new HttpHeaders({    
  'content-Type': 'application/json',
  'authorization': 'Bearer '+ this.labData!=null ?  this.labData['accessToken'] : '' ,
  'accept': 'application/json',

});
   }
  addTest(labTestData,labData){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });
    
    return this.http.post(`${this.apiUrl}/Labs/addLabTests`,labTestData,{headers:headers1})

  }
  getLabsTests(labsData){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });
  
    return this.http.post(`${this.apiUrl}/Labs/listLabTests`,{},{headers:headers1})
  }
  updateLabTest(testObj){
 
    
    delete testObj['createdAt']
    delete testObj['isDeleted']
    delete testObj['labId']
    delete testObj['__v']

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });
    return this.http.post(`${this.apiUrl}/Labs/addLabTests`,testObj,{headers:headers1})
  }
  deleteLabTest(testObjID,labData:any){
   
let data = { _id:testObjID }
let accesstoken = localStorage.getItem('token')
let headers1 = new HttpHeaders({    
  'content-Type': 'application/json',
  'authorization': 'Bearer '+ accesstoken ,
  'accept': 'application/json',

});
    return this.http.post(`${this.apiUrl}/Labs/deleteTest`,data,{headers:headers1})

  }


  // User Side//


  getLabsList(object={value:{name:'',city:'',tests:''}}){
    let lat = localStorage.getItem('lat') 
    let lng = localStorage.getItem('lng') 
    let params= {}
    if (lat=='undefined'){}
    else{
      params["lat"] = lat
    } 
      
    if (lng=='undefined'){}
    else{ 
      params["lng"] = lng 
    }

    if(object.value.name)
      params["name"] = object.value.name
    if(object.value.tests)
      params["tests"] = object.value.tests
    if(object.value.city)
      params["city"] = object.value.city.toLowerCase()


    const httpOptions = {
      
      params: params
  };
  
    return this.http.get(`${this.apiUrl}/User/listLabs`,httpOptions)
  }
  getLabDetail(labId:string,date){
    let params= {}
    params["_id"] = labId
    params["selectDate"] = date
    const httpOptions = {
      
      params: params
  };
  return this.http.get(`${this.apiUrl}/User/listLabsDetails`,httpOptions)
  }
  bookLabTest(labTests,addressFields){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
  
    });
    let data = {
      labTestId:labTests,
      ...addressFields
    }
   
    return this.http.post(`${this.apiUrl}/User/labBooking`,data,{headers:headers1})
  }
  bookLabTestByLab(labTests,addressFields,phoneNo,countryCode){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
  
    });
    let data = {
      phoneNo:phoneNo,
      countryCode:countryCode,
      labTestId:labTests,
      ...addressFields
    }
   
    return this.http.post(`${this.apiUrl}/Labs/createOrder`,data,{headers:headers1})
  }
  labBookings(date=null,phoneNo=''){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });
    if (date && phoneNo) 
      return this.http.get(`${this.apiUrl}/Labs/listBookings?date=${date}&phoneNo=${phoneNo}`,{headers:headers1})
      
    else if (phoneNo) 
      return this.http.get(`${this.apiUrl}/Labs/listBookings?phoneNo=${phoneNo}`,{headers:headers1})
    else if(date)
      return this.http.get(`${this.apiUrl}/Labs/listBookings?date=${date}`,{headers:headers1})
    else
    return this.http.get(`${this.apiUrl}/Labs/listBookings`,{headers:headers1})
  //return this.http.get(`${this.apiUrl}/Labs/listBookings`,{headers:headers1}) 
  }
  updateBookingStatus(status:string,bookingID:string){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
  
    });

    return this.http.put(`${this.apiUrl}/Labs/bookingStatusUpdate`,{_id:bookingID,status:status},{headers:headers1})
  }
  setPasword(password){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });
    
    return this.http.put(`${this.apiUrl}/Labs/setPassword`,{ password : password},{headers:headers1})
  }
  getReviews(){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
  
    });
  
  
    return this.http.get(`${this.apiUrl}/Labs/listReview`,{headers:headers1})
  

}
getPatientGraphData(){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });


  return this.http.get(`${this.apiUrl}/Labs/patientGraph`,{headers:headers1})
}
getRevenueGraphData(){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });


  return this.http.get(`${this.apiUrl}/Labs/revenueGraph`,{headers:headers1})
}
uploadReports(bookingId,reports){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });

return this.http.put(`${this.apiUrl}/Labs/uploadReports`,{bookingId:bookingId,reports:reports},{headers:headers1})
 
}
labDistance(addressFields,labId){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });

return this.http.get(`${this.apiUrl}/User/labDistance?labId=${labId}&lat=${addressFields.lat}&lng=${addressFields.lng}`,{headers:headers1})
}
getTimingStatus(labId,addressFields){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });

return this.http.get(`${this.apiUrl}/User/labTimingStatus?labId=${labId}&time=${addressFields.dateTime}`,{headers:headers1})
}
addMultipleTest(labTests){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });
  return this.http.post(`${this.apiUrl}/Labs/inesrtLabTests`,{tests:labTests},{headers:headers1})

}
addDescription(bookingId,description){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });
  console.log(bookingId)
  return this.http.put(`${this.apiUrl}/Labs/writeDescription`,{bookingId:bookingId,description:description},{headers:headers1})
}
deleteReport(bookingId,report){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });
  console.log(bookingId)
  return this.http.put(`${this.apiUrl}/Labs/deleteReports`,{bookingId:bookingId,reports:report},{headers:headers1})

}
}
